import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/common/Icon';

interface ListSearchInputProps {
  value: string;
  onChange: (nextValue: string) => void;
  placeholder: string;
}

export function ListSearchInput({ value, onChange, placeholder }: ListSearchInputProps) {
  const { t } = useTranslation('common');

  return (
    <div className="flex items-center gap-2 px-4 py-2.5 bg-zoowhite border border-zooborder rounded-xl w-full sm:max-w-md">
      <Icon name="Search" className="text-zoomuted" />
      <input
        type="search"
        value={value}
        placeholder={placeholder}
        onChange={function handleChange(changeEvent) {
          onChange(changeEvent.target.value);
        }}
        className="flex-1 min-w-0 bg-transparent text-sm text-zooindigo focus:outline-none placeholder:text-zoomuted"
      />
      {value.length > 0 ? (
        <button
          type="button"
          aria-label={t('actions.clear')}
          onClick={function clearSearch() {
            onChange('');
          }}
          className="w-6 h-6 flex items-center justify-center rounded-md text-zoomuted hover:text-zooindigo transition-colors"
        >
          <Icon name="X" />
        </button>
      ) : null}
    </div>
  );
}
